import { queryClient } from 'App';

import { appointmentQueryKeys } from 'lib/constants/constants';

export default () => {
  appointmentQueryKeys.forEach((key) => {
    queryClient.invalidateQueries({
      queryKey: [key],
      exact: false
    });
  });
};
